import { render, staticRenderFns } from "./friendlyLink.vue?vue&type=template&id=724d9f4b&scoped=true&"
import script from "./friendlyLink.vue?vue&type=script&lang=js&"
export * from "./friendlyLink.vue?vue&type=script&lang=js&"
import style0 from "./friendlyLink.vue?vue&type=style&index=0&id=724d9f4b&lang=less&scoped=true&"
import style1 from "./friendlyLink.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d9f4b",
  null
  
)

export default component.exports